import { createSlice } from "@reduxjs/toolkit";

import { invoicesApi } from "../services/invoices";
import type { RootState } from "../../store";
import type { InvoiceCounts, InvoiceShort } from "../../types/InvoiceTypes";
import { ResponsePage } from "../../types/GlobalTypes";

type InvoicesState = {
  data: ResponsePage<InvoiceShort> | undefined;
  counts: InvoiceCounts | undefined;
};

const initialState: InvoicesState = {
  data: undefined,
  counts: undefined,
};

export const PAGE_SIZE = 10;

const invoicesSlice = createSlice({
  name: "invoices",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addMatcher(
        invoicesApi.endpoints.getInvoices.matchFulfilled,
        (state, { payload }) => {
          state.data = {
            count: payload.count,
            pages: Math.ceil(payload.count / PAGE_SIZE),
            hasNext: !!payload.next,
            hasPrevious: !!payload.previous,
            results: !payload.previous
              ? payload.results
              : [...(state.data?.results || []), ...payload.results],
          };
        }
      )
      .addMatcher(
        invoicesApi.endpoints.getInvoicesCounts.matchFulfilled,
        (state, { payload }) => {
          state.counts = payload;
        }
      );
  },
});

export default invoicesSlice.reducer;

export const selectInvoices = (state: RootState) => state.invoices.data;
export const selectInvoicesCounts = (state: RootState) => state.invoices.counts;
